var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/Terms"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.737 3.477h4.139c1.725 0 3.124 1.343 3.124 3V18.5c0 1.657-1.399 3-3.124 3h-2.38m0 0H6.124C4.4 21.5 3 20.157 3 18.5v-.194l.045-11.548V5.5c0-1.657 1.398-3 3.124-3h6.595m2.732 19c1.726 0 3.124-1.343 3.124-3V8.385m-8.975 5.606h5.602m3.373-5.606h-4.502c-.748 0-1.354-.582-1.354-1.3V2.5m5.856 5.885L12.764 2.5M10.457 6H6.014h2.167v5m1.464 5.886h5.478m-8.398-2.895h.522m-.522 2.895h.522",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/Terms.a2825db951334719b31c1a712f60e177.svg";
export { ForwardRef as ReactComponent };